module.exports = __webpack_public_path__ + "media/images/emblems/Niedermuhlern-coat_of_arms-9ad1159c2c1d2ab132f03e196e7fbea3.svg";